import { takeEvery } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { fetchVisitSuccess } from '../actions';
import { STORE_UNIT } from '../constants/actionTypes';
import { getVisit } from '../repository';


function *_fetchVisitOnStoreUnit({vtrac}) {

    try {
        let visit = yield call(getVisit(vtrac));

        yield put(fetchVisitSuccess(visit));
    } catch (error) {
        //Do nothing
    }
}

export function *fetchVisitOnStoreUnit() {
    yield takeEvery(STORE_UNIT.SUCCESS, _fetchVisitOnStoreUnit);
}
